import { makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { SubmitDialog } from "@roc/ui";
import { useDocumentStore } from "@roc/feature-documents";
import { EditPayoffFieldsForm } from "./editPayoffFieldsForm";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const EditPayoffFieldsDialog = observer(({ }) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <div>
      <SubmitDialog
        open={payoffCalculatorStore.isEditPayoffFieldsDialogOpen}
        title="Edit Payoff Fields"
        maxWidth="md"
        handleOk={() => payoffCalculatorStore.savePayoffFields()}
        handleClose={() => payoffCalculatorStore.setIsEditPayoffFieldsDialogOpen(false)}
        body={
          <EditPayoffFieldsForm />
        }
        cancelButtonText={'Cancel'}
        okButtonText={'Save'}
      />
    </div>
  );
});
